import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";

import {StartECaseComponent} from "./start-ecase.component";
import {FilterPipe} from "../pipes/filter-pipe";
import {StartECaseService} from "../start-ecase-service";
import {ArraySortPipe} from "../pipes/sort-pipe";

@NgModule({
  declarations: [
    StartECaseComponent,
    FilterPipe,
    ArraySortPipe
  ],
  imports: [
    BrowserModule, FormsModule, HttpClientModule
  ],
  providers: [StartECaseService],
  bootstrap: [StartECaseComponent]
})
export class StartECaseModule { }



// WEBPACK FOOTER //
// ./src/app/start-ecase/start-ecase.module.ts